<template>
  <div class="page">    
    <PageFull titlePage noOverlay>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/las_vegas_market/end-image_las-vegas-market.jpg" alt=""></div>                
            </div>
        </div>
    </template>
    </PageFull>    
  </div>
</template>

<script>
import PageFull from "@/patterns/PageFull.vue";
export default {
  name: "TheStadiumEnd",
  components: { PageFull }  
};
</script>
